module.exports = [
 {
  "start": 41,
  "end": 1875,
  "text": "Upside Down Table is a projection "
 },
 {
  "start": 1917,
  "end": 4000,
  "text": "onto a round dining table, "
 },
 {
  "start": 4083,
  "end": 5667,
  "text": "and it belongs to my research "
 },
 {
  "start": 5750,
  "end": 7834,
  "text": "how and if the moving electronic image "
 },
 {
  "start": 7959,
  "end": 10000,
  "text": "can also unite people "
 },
 {
  "start": 10166,
  "end": 12708,
  "text": "when often it rather separates us "
 },
 {
  "start": 12792,
  "end": 14291,
  "text": "or forces a group to watch "
 },
 {
  "start": 14333,
  "end": 15792,
  "text": "in only one direction. "
 },
 {
  "start": 15959,
  "end": 17458,
  "text": "This question accompanies me "
 },
 {
  "start": 17542,
  "end": 18792,
  "text": "since a long time, "
 },
 {
  "start": 18875,
  "end": 21125,
  "text": "while the sun is our biggest projector "
 },
 {
  "start": 21208,
  "end": 24375,
  "text": "and our eyes are blood driven cameras."
 }
]


// WEBPACK FOOTER //
// ./src/Rist/content/tourWorks/room8/audio3/08_3MCA Upside Down Table.js